import React from "react"
import styled from "styled-components"

import { minWidth } from "utils"

import Icon from "icons"
import ArticleCard from "../article-card"
import Grid from "components/grid"

export const Container = styled.div`
  display: none;

  ${minWidth.tablet`
    padding: 0 10rem 5rem;
    display: block;
  `}
`

export const Row = styled.div`
  ${minWidth.hamburgerLarge`
    display: flex;
  `}
`

export const Left = styled.div`
  width: 100%;
  padding-bottom: 2rem;

  ${minWidth.hamburgerLarge`
    width: 50%;
    padding-right: 2rem;
    padding-bottom: 0;
  `}

  ${minWidth.desktopL`
    width: 60.25%;
  `}
`

export const Right = styled.div`
  width: 100%;

  ${minWidth.hamburgerLarge`
    width: 50%;
    padding-left: 2rem;
  `}

  ${minWidth.desktopL`
    width: 39.75%;
  `}
`

export const StyledGrid = styled(Grid)`
  padding: 0;
`

export const BigCard = styled(ArticleCard)`
  margin: 0 !important;
`

export const SmallCard = styled(ArticleCard)`
  display: none;

  ${minWidth.hamburgerLarge`
    margin: 0 0 4rem !important;
    display: flex;
  `}
`

export const SmallCardTablet = styled(ArticleCard)`
  ${minWidth.hamburgerLarge`
    display: none;
  `}
`

export const MobileWrapper = styled.div`
  position: relative;
  padding: 0 1.2rem;

  ${minWidth.tablet`
    display: none;
  `}
`

const ScrollLabel = styled.div`
  margin-top: 2rem;
  font-size: 1.6rem;
  line-height: 2.2rem;
`

const ScrollArrowLineMobile = styled(Icon)`
  ${minWidth.mobile`
    display: none;
  `}
`

const ScrollArrowLineDesktop = styled(Icon)`
  display: none;

  ${minWidth.mobile`
    display: block;
  `}
`

export const Scroll = () => (
  <>
    <ScrollLabel>scroll</ScrollLabel>
    <ScrollArrowLineMobile viewBox="0 0 348 12" id="arrow-line-mobile" />
    <ScrollArrowLineDesktop viewBox="0 0 823 12" id="arrow-line-desktop" />
  </>
)

export const ScrollContainer = styled.div`
  width: 100%;
  margin: 1rem 0 3rem;
`

export const ScrollableGrid = styled.div`
  display: -webkit-box;
  overflow-x: auto;
`

export const MobileCard = styled(ArticleCard)`
  width: 20rem;
  margin-right: 0.7rem;
  margin-left: 0.7rem;

  :first-child {
    margin-left: 0;
  }

  :last-child {
    margin-right: 0;
  }

  /* image */
  > a > div > div {
    padding-bottom: 100%;
  }

  /* header */
  > div {
    padding: 1.3rem 0;
  }
`

export const Line = styled.div`
  width: 100%;
  height: 0.1rem;
  background-color: #222;
`
